import { getOrg } from '../components/reports/helper/helper';

const isCrown = () => getOrg() === '5ab394671d41c808a952f9b4';

export { isCrown };
